<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <!-- <div class="col-sm-12"> -->
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                   
                    {
                      title: 'Training Material Approval',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Trainee Materials Approval</h3>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-sm-12">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <tr>
                                    <th>Sr#</th>
                                    <th>Name</th>
                                    <th>Event Title</th>
                                    <th>Added at</th>
                                    <th>File</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                <tr v-for="(item, index) in traineeArr" v-bind:key="item.id">
                                    <td>{{index+1}}</td>
                                    <td>{{item.title}}</td>
                                    <td>{{item.training_material.title}}</td>
                                    <td>{{item.createdAt | formatDate}}</td>
                                    <th>
                                        <a :href="BASEPATHDYNAMIC+'/'+item.uploadfile" target="_blank">
                                            <vs-icon class="mr-4" icon="file_download" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                        </a>
                                    </th>
                                    <td>
                                        <vs-chip v-if="item.statusApproval == '1'" color="primary">Pending</vs-chip>
                                        <vs-chip v-if="item.statusApproval == '2'" color="success">Approved</vs-chip>
                                        <vs-chip v-if="item.statusApproval == '3'" color="danger">Reject</vs-chip>
                                    </td>
                                    <td>
                                        <a @click="approvedTrainee(item.id)">
                                            <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                        </a>
                                        <a @click="rejectTrainee(item.id)">
                                            <vs-icon class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import axios from "axios";
export default {
    data: () => ({
        isSidebar: false,
        trainingId: "",
        trainingCode: "",
        traineeArr: [],
        BASEPATHDYNAMIC: ""
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.training.id;
                this.getTraineeMaterial();
            });
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        getTraineeMaterial() {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/traineematerial/get/all/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.traineeArr = response.data;
                });
        },
        approvedTrainee(id) {
            let self = this;
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH + "/traineematerial/single/update", {
                        statusApproval: 2,
                        id: id
                    }

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        self.toastSuccess("Trainee Material Approved successfully!");
                        this.getTraineeMaterial();
                    } else if (response.data.error) {
                        throw response.data.error;
                    }
                })
                .catch(error => {
                    self.toastError(error);
                });
        },
        rejectTrainee(id) {
            let self = this;
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH + "/traineematerial/single/update", {
                        statusApproval: 3,
                        id: id
                    }

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        self.toastSuccess("Trainee Material Reject successfully!");
                        this.getTraineeMaterial();
                    } else if (response.data.error) {
                        throw response.data.error;
                    }
                })
        }
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    }
};
</script>

<style scoped>
</style>
